import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { 
  FiCoffee, FiSun, FiStar, FiMapPin, FiClock, FiShoppingBag, 
  FiArrowRight, FiHeart, FiMail, FiPhone, FiGlobe, FiMenu, 
  FiX, FiDroplet, FiThermometer, FiChevronUp
} from 'react-icons/fi';
import { 
  FaUtensils, FaMugHot, FaLeaf, FaAppleAlt, 
  FaWineBottle, FaWhatsapp, FaFacebook, FaInstagram,
  FaBreadSlice, FaCheese, FaEgg, FaHamburger
} from 'react-icons/fa';
import { GiCoffeeCup, GiCroissant, GiOrange, GiAvocado } from 'react-icons/gi';
import logo from '../Assets/logometropole.png';

const Carte = () => {
  const [activeCategory, setActiveCategory] = useState('cafe');
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [showScrollButton, setShowScrollButton] = useState(false);

  // Gestion du scroll pour le bouton
  useEffect(() => {
    const handleScroll = () => {
      setShowScrollButton(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Fonction pour remonter en haut
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  // Fonction pour réserver (appel téléphonique)
  const handleReservation = () => {
    window.location.href = 'tel:+212522820267';
  };

  // Catégories du menu
  const categories = [
    { id: 'cafe', name: 'Café', icon: <GiCoffeeCup />, color: 'from-[#5C4033] to-[#3E2723]' },
    { id: 'chaudes', name: 'Boissons Chaudes', icon: <FaMugHot />, color: 'from-[#5C4033] to-[#4A3728]' },
    { id: 'froides', name: 'Boissons Froides', icon: <FaWineBottle />, color: 'from-[#5C4033] to-[#1B5E20]' },
    { id: 'jus', name: 'Jus de Fruits', icon: <GiOrange />, color: 'from-[#5C4033] to-[#1B5E20]' },
    { id: 'petitdej', name: 'Petits Déjeuners', icon: <FaEgg />, color: 'from-[#5C4033] to-[#3E2723]' }
  ];

  // Données du menu
  const menuData = {
    cafe: [
      { name: 'Espresso', price: '13 DH', description: 'Café italien intense et corsé' },
      { name: 'Café Allongé', price: '13 DH', description: 'Expresso allongé à l\'eau chaude' },
      { name: 'Café Noir', price: '13 DH', description: 'Café filtre classique' },
      { name: 'Double Espresso', price: '15 DH', description: 'Double dose d\'expresso' }
    ],
    chaudes: [
      { name: 'Café Crème', price: '14 DH', description: 'Expresso avec crème légère' },
      { name: 'Café au Lait', price: '14 DH', description: 'Café et lait chaud' },
      { name: 'Chocolat Chaud', price: '14 DH', description: 'Chocolat chaud onctueux' },
      { name: 'Latte Macchiato', price: '14 DH', description: 'Lait chaud avec expresso' },
      { name: 'Cappuccino', price: '15 DH', description: 'Expresso, lait et mousse de lait' },
      { name: 'Thé à la Menthe', price: '15 DH', description: 'Thé vert frais à la menthe' },
      { name: 'Thé à la Menthe (à partager)', price: '25 DH', description: 'Grande théière à partager' }
    ],
    froides: [
      { name: 'Sodas', price: '15 DH', description: 'Coca-Cola, Fanta, Sprite' },
      { name: 'Oulmes', price: '12 DH', description: 'Eau gazeuse' },
      { name: 'Eau Sidi Ali 50cl', price: '12 DH', description: 'Eau minérale naturelle' },
      { name: 'Eau Sidi Ali 33cl', price: '3 DH', description: 'Eau minérale naturelle' }
    ],
    jus: [
      { name: 'Jus d\'Orange', price: '18 DH', description: 'Orange fraîche pressée', icon: <GiOrange className="text-xl" /> },
      { name: 'Jus de Mangue', price: '22 DH', description: 'Mangue fraîche', icon: <GiAvocado className="text-xl" /> },
      { name: 'Jus de Fraise', price: '22 DH', description: 'Fraise fraîche', icon: <FaAppleAlt className="text-xl" /> },
      { name: 'Jus d\'Ananas', price: '25 DH', description: 'Ananas frais', icon: <FaAppleAlt className="text-xl" /> },
      { name: 'Jus d\'Avocat', price: '25 DH', description: 'Avocat frais', icon: <GiAvocado className="text-xl" /> },
      { name: 'Jus de Panaché', price: '30 DH', description: 'Mélange de fruits frais' }
    ],
    petitdej: [
      { 
        name: 'Petit Déjeuner Express', 
        price: '25 DH', 
        description: 'Croissant, fromage, jus d\'orange, boisson chaude',
        icon: <GiCroissant className="text-xl" />
      },
      { 
        name: 'Petit Déjeuner Marocain', 
        price: '25 DH', 
        description: 'Pizza marocaine au zaatar, jus d\'orange, boisson chaude',
        icon: <FaBreadSlice className="text-xl" />
      },
      { 
        name: 'Petit Déjeuner Charcuterie', 
        price: '35 DH', 
        description: 'Omelette, charcuterie, pain, jus, boisson chaude',
        icon: <FaHamburger className="text-xl" />
      },
      { 
        name: 'Petit Déjeuner Fromage rouge', 
        price: '35 DH', 
        description: 'Omelette, fromage rouge, pain, jus, boisson chaude',
        icon: <FaCheese className="text-xl" />
      },
      { 
        name: 'Petit Déjeuner au Khlii', 
        price: '40 DH', 
        description: 'Omelette au khlii, pain, jus, boisson chaude',
        icon: <FaEgg className="text-xl" />
      },
      { 
        name: 'Petit Déjeuner Amazigh', 
        price: '40 DH', 
        description: 'Msemen, amlou, miel, fromage, jus, boisson chaude',
        icon: <GiCroissant className="text-xl" />
      }
    ]
  };

  // Informations supplémentaires
  const info = {
    water: 'Eau 33cl incluse avec toutes les boissons chaudes',
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header - Style marron et blanc */}
      <header className="bg-white shadow-md sticky top-0 z-50 border-b border-[#D4A574]">
        <div className="container mx-auto px-4 py-3">
          <div className="flex justify-between items-center">
            <Link to="/" className="flex items-center group">
              <img 
                src={logo} 
                alt="Espace Metropole" 
                className="h-12 w-auto object-contain"
              />
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center space-x-6">
              <Link to="/" className="text-[#5C4033] hover:text-[#1B5E20] font-medium text-sm uppercase tracking-wider transition-colors">
                Accueil
              </Link>
              <Link to="/carte" className="text-[#1B5E20] font-medium text-sm uppercase tracking-wider border-b-2 border-[#1B5E20] pb-1">
                Notre Menu
              </Link>
              <a href="/#offres" className="text-[#5C4033] hover:text-[#1B5E20] font-medium text-sm uppercase tracking-wider transition-colors">
                Offres
              </a>
              <button 
                onClick={handleReservation}
                className="bg-[#5C4033] text-white px-5 py-2 rounded-full hover:bg-[#1B5E20] transition-all text-sm uppercase tracking-wider font-semibold flex items-center gap-2 shadow-md"
              >
                <FiHeart className="text-sm" />
                Réserver
              </button>
            </nav>

            {/* Mobile Menu Button */}
            <button 
              onClick={() => setShowMobileMenu(!showMobileMenu)}
              className="md:hidden p-2 rounded-lg hover:bg-[#F5E6D3]"
            >
              {showMobileMenu ? <FiX className="text-2xl text-[#5C4033]" /> : <FiMenu className="text-2xl text-[#5C4033]" />}
            </button>
          </div>

          {/* Mobile Navigation */}
          <div className={`md:hidden transition-all duration-300 overflow-hidden ${
            showMobileMenu ? 'max-h-96 opacity-100 mt-3' : 'max-h-0 opacity-0'
          }`}>
            <div className="flex flex-col space-y-2 pb-3">
              <Link to="/" className="text-[#5C4033] hover:text-[#1B5E20] py-2" onClick={() => setShowMobileMenu(false)}>
                Accueil
              </Link>
              <Link to="/carte" className="text-[#1B5E20] py-2" onClick={() => setShowMobileMenu(false)}>
                Notre Menu
              </Link>
              <a href="/#offres" className="text-[#5C4033] hover:text-[#1B5E20] py-2" onClick={() => setShowMobileMenu(false)}>
                Offres
              </a>
              <button 
                onClick={() => {
                  handleReservation();
                  setShowMobileMenu(false);
                }}
                className="bg-[#5C4033] text-white px-5 py-2 rounded-full font-semibold flex items-center justify-center gap-2 text-sm"
              >
                <FiHeart />
                Réserver
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Hero Section - Marron */}
      <section className="relative py-16 px-4 bg-[#5C4033] text-white">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="container mx-auto relative z-10 text-center">
          <div className="inline-block mb-2">
            <div className="w-12 h-0.5 bg-[#A5D6A7] mx-auto mb-1"></div>
            <span className="text-[#A5D6A7] tracking-wider text-xs uppercase">Découvrez notre</span>
          </div>
          <h1 className="text-4xl md:text-6xl font-bold mb-2">Carte & Menu</h1>
          <p className="text-lg md:text-xl mb-4 font-light max-w-2xl mx-auto font-serif">
            Cafés, boissons et petits déjeuners
          </p>
        </div>
      </section>

      {/* Categories Navigation - Compact */}
      <div className="sticky top-[60px] z-40 bg-white shadow-sm py-2 overflow-x-auto border-b border-[#F5E6D3]">
        <div className="container mx-auto px-4">
          <div className="flex gap-2 justify-center min-w-max">
            {categories.map(cat => (
              <button
                key={cat.id}
                onClick={() => setActiveCategory(cat.id)}
                className={`flex items-center gap-1.5 px-4 py-2 rounded-full transition-all text-sm whitespace-nowrap ${
                  activeCategory === cat.id
                    ? `bg-gradient-to-r ${cat.color} text-white shadow-md`
                    : 'bg-[#F5F0E8] text-[#5C4033] hover:bg-[#EDE5D8]'
                }`}
              >
                <span className="text-base">{cat.icon}</span>
                <span className="font-medium">{cat.name}</span>
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Menu Content - Compact */}
      <section className="py-8 px-4 bg-white">
        <div className="container mx-auto max-w-4xl">
          {/* Category Header - Compact */}
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-[#F5E6D3] mb-2">
              <span className="text-2xl text-[#5C4033]">
                {categories.find(c => c.id === activeCategory)?.icon}
              </span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-[#5C4033]">
              {categories.find(c => c.id === activeCategory)?.name}
            </h2>
            <div className="w-16 h-0.5 bg-[#1B5E20] mx-auto mt-2"></div>
          </div>

          {/* Menu Items Grid - Compact */}
          <div className="space-y-2">
            {menuData[activeCategory].map((item, index) => (
              <div 
                key={index}
                className="bg-white rounded-xl shadow hover:shadow-md transition-all overflow-hidden group border border-[#F5E6D3]"
              >
                <div className="p-4 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-1">
                      {item.icon && (
                        <span className="text-[#1B5E20]">{item.icon}</span>
                      )}
                      <h3 className="text-lg md:text-xl font-bold text-[#5C4033] group-hover:text-[#1B5E20] transition-colors">
                        {item.name}
                      </h3>
                    </div>
                    <p className="text-[#8B6914] text-sm leading-relaxed">{item.description}</p>
                  </div>
                  <div className="flex items-center gap-3">
                    <span className="text-xl md:text-2xl font-bold text-[#1B5E20] whitespace-nowrap">
                      {item.price}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Special Notes - Compact */}
          <div className="mt-8 bg-[#F5E6D3] rounded-xl p-4 text-center border border-[#D4A574]">
            <div className="flex items-center justify-center gap-2 text-[#5C4033] mb-1 text-sm">
              <FiDroplet className="text-base" />
              <p className="font-semibold">{info.water}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action - Marron et Vert Foncé */}
      <section className="py-10 px-4 bg-[#5C4033]">
        <div className="container mx-auto text-center text-white">
          <h3 className="text-2xl md:text-3xl font-bold mb-2">Envie de réserver ?</h3>
          <p className="text-base mb-4 opacity-90">Réservez votre table et profitez de nos menus</p>
          <button 
            onClick={handleReservation}
            className="bg-white text-[#5C4033] px-8 py-2.5 rounded-full text-base font-semibold hover:bg-[#1B5E20] hover:text-white shadow-lg transform hover:scale-105 transition-all inline-flex items-center gap-2"
          >
            <FiHeart />
            Réserver maintenant
            <FiArrowRight />
          </button>
        </div>
      </section>

      {/* Footer - Marron et Vert Foncé */}
      <footer className="bg-[#5C4033] text-white py-10">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center md:text-left">
              <div className="flex items-center justify-center md:justify-start mb-3">
                <div className="bg-white rounded-lg p-1.5 shadow-lg">
                  <img src={logo} alt="Logo" className="h-8 w-auto object-contain" />
                </div>
              </div>
              <p className="text-[#D4C4A8] text-sm">
                L'élégance au cœur de Casablanca
              </p>
            </div>
     
            
            <div className="text-center">
              <h4 className="text-base font-semibold mb-3 text-[#A5D6A7]">Contact</h4>
              <ul className="space-y-2 text-sm">
                <li className="flex items-center justify-center gap-2 text-[#D4C4A8]">
                  <FiPhone className="text-[#A5D6A7] text-xs" />
                  <span>(+212) 522-820-267</span>
                </li>
                <li className="flex items-center justify-center gap-2 text-[#D4C4A8] text-xs">
                  <FiMail className="text-[#A5D6A7]" />
                  <span>contact@espace-metropole.ma</span>
                </li>
                <li className="flex items-center justify-center gap-2 text-[#D4C4A8] text-xs">
                  <FiMapPin className="text-[#A5D6A7]" />
                  <span>Angle Bd 2 mars, Casablanca</span>
                </li>
              </ul>
            </div>
            
            <div className="text-center md:text-right">
              <h4 className="text-base font-semibold mb-3 text-[#A5D6A7]">Suivez-nous</h4>
              <div className="flex justify-center md:justify-end space-x-3">
                <a href="#" className="w-8 h-8 bg-[#7A5C48] rounded-full flex items-center justify-center hover:bg-[#1B5E20] transition-all">
                  <FaFacebook className="text-sm" />
                </a>
                <a href="#" className="w-8 h-8 bg-[#7A5C48] rounded-full flex items-center justify-center hover:bg-[#1B5E20] transition-all">
                  <FaInstagram className="text-sm" />
                </a>
                <a href="#" className="w-8 h-8 bg-[#7A5C48] rounded-full flex items-center justify-center hover:bg-[#1B5E20] transition-all">
                  <FaWhatsapp className="text-sm" />
                </a>
              </div>
            </div>
          </div>
          
          <div className="border-t border-[#7A5C48] mt-8 pt-6 text-center text-[#C4A77D] text-xs">
            <p>&copy; 2026 Espace Metropole. Tous droits réservés.</p>
          </div>
        </div>
      </footer>

      {/* Bouton Scroll to Top - Marron et Vert */}
      <button
        onClick={scrollToTop}
        className={`fixed bottom-6 right-4 md:hidden bg-[#1B5E20] text-white p-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-110 z-40 ${
          showScrollButton ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10 pointer-events-none'
        }`}
        aria-label="Retour en haut"
      >
        <FiChevronUp className="text-xl" />
      </button>
    </div>
  );
};

export default Carte;